const pieChartCanvas = document.getElementById("pieChart");

if(pieChartCanvas) {
const pieChart = new rive.Rive({
  src: "/wp-content/themes/grayce/assets/rive/pie_charts.riv",
  canvas: document.getElementById("pieChart"),
  autoplay: false,
  onLoad: () => {
  pieChart.resizeDrawingSurfaceToCanvas();
  },
});

document.addEventListener('DOMContentLoaded', function () {
  const animation = document.getElementById("pieChart");
  function playOnScroll() {
    const viewportHeight = window.innerHeight;
    const playerTop = animation.getBoundingClientRect().top;
    if (playerTop < viewportHeight * 0.5) {
         pieChart.play();
    }
  }
  window.addEventListener('scroll', playOnScroll);
  playOnScroll();
});
}

const waterFillCanvas = document.getElementById("waterFill");
if(waterFillCanvas) {
const waterFill = new rive.Rive({
  src: "/wp-content/themes/grayce/assets/rive/water_fill.riv",
  canvas: document.getElementById("waterFill"),
  autoplay: false,
  onLoad: () => {
  waterFill.resizeDrawingSurfaceToCanvas();
  },
});

document.addEventListener('DOMContentLoaded', function () {
  const animation = document.getElementById("waterFill");
  function playOnScroll() {
    const viewportHeight = window.innerHeight;
    const playerTop = animation.getBoundingClientRect().top;
    if (playerTop < viewportHeight * 0.5) {
         waterFill.play();
    }
  }
  window.addEventListener('scroll', playOnScroll);
  playOnScroll();
});
}

const tickerCanvas = document.getElementById("ticker");
if(tickerCanvas) {
const ticker = new rive.Rive({
  src: "/wp-content/themes/grayce/assets/rive/45_and_40.riv",
  canvas: document.getElementById("ticker"),
  autoplay: false,
  onLoad: () => {
  ticker.resizeDrawingSurfaceToCanvas();
  },
});

document.addEventListener('DOMContentLoaded', function () {
  const animation = document.getElementById("ticker");
  function playOnScroll() {
    const viewportHeight = window.innerHeight;
    const playerTop = animation.getBoundingClientRect().top;
    if (playerTop < viewportHeight * 0.5) {
         ticker.play();
    }
  }
  window.addEventListener('scroll', playOnScroll);
  playOnScroll();
});
}

const ringChartCanvas = document.getElementById("ringChart");
if(ringChartCanvas) {
const ringChart = new rive.Rive({
  src: "/wp-content/themes/grayce/assets/rive/ring_graphs.riv",
  canvas: document.getElementById("ringChart"),
  autoplay: false,
  onLoad: () => {
  ringChart.resizeDrawingSurfaceToCanvas();
  },
});

document.addEventListener('DOMContentLoaded', function () {
  const animation = document.getElementById("ringChart");
  function playOnScroll() {
    const viewportHeight = window.innerHeight;
    const playerTop = animation.getBoundingClientRect().top;
    if (playerTop < viewportHeight * 0.5) {
         ringChart.play();
    }
  }
  window.addEventListener('scroll', playOnScroll);
  playOnScroll();
});
}